module.exports = __webpack_public_path__ + "img/icon118.a4491f4c.png";